import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'

export const getBankQuickAssessmentThunk = createAsyncThunk(
  'financialAnalysis/Bank/getBankQuickAssessment',
  async (data, { rejectWithValue }) => {
    const response = await FinancialAnalysisService.getBankQuickAssessment(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadBankQuickAssessment = createAsyncThunk(
  'financialAnalysis/Bank/downloadBankQuickAssessment',
  async (data) => {
    const response = await FinancialAnalysisService.downloadBankQuickAssessment(
      data,
    )
    handleExport(response.data, response.filename)
  },
)
